export class PopExternalLinkWarning {
  constructor() {
    this.popExternalLink = jQuery(".external-link-warning-popup");
    this.externalLinkTxt = jQuery(".external-link-txt");
    this.externalURL = "";
    this.closeBtn = jQuery('.external-link-warning-popup .btn-cancel, .external-link-warning-popup .pop-close-btn');
    this.confirmBtn = jQuery('.external-link-warning-popup .btn-confirm')
    this.setupHandlers()
  }

  setExternalUrlText(url) {
    this.externalLinkTxt.text(url);
  }

  showExternalLinkPopup() {
    this.popExternalLink.addClass("show");
    jQuery("body").addClass("pop-open-no-scroll");
  }

  hideExternalLinkPopup() {
    this.popExternalLink.removeClass("show");
    jQuery("body").removeClass("pop-open-no-scroll");
  }

  setupHandlers() {
    let that = this;
    this.closeBtn.click(function () {
      that.hideExternalLinkPopup();
    });

    this.confirmBtn.click(function () {
      window.open(that.externalURL, "_blank");
      that.hideExternalLinkPopup();
    });

    // catch all external links and display the popup
    jQuery(document).on('click', 'a.external-link', function (event) {
      var el = event.currentTarget;
      var href = jQuery(el).attr('href');
      if (typeof (href) != 'undefined' && href !== null) {
        event.preventDefault();
        // Set the href for the popup
        that.setExternalUrlText(href);
				that.externalURL = href;
        //lauch the popup
        that.showExternalLinkPopup();
        return false;
      }
    });
  }

  static setup() {
    return new PopExternalLinkWarning()
  }
}